import {IOptionItemAvailableChoice} from "@bimaire/optionslib";

export function getOptionNameMap(optSel: string, values: IOptionItemAvailableChoice[]) {
    let retval: Map<IOptionItemAvailableChoice, {
        name: string,
        details?: string
    }> = new Map<IOptionItemAvailableChoice, { name: string; details?: string }>()
    /*if (optSel === "EXT_COLORS") {

        let index = 1;
        for (const vn of values) {
            if (vn.items[1].item.name.toLocaleLowerCase().includes("not selected")) {
                retval.set(vn, {name: vn.items[1].item.name});
            } else {
                retval.set(vn, {name:`Package ${index++}`, details: vn.items[1].item.name});
            }
        }
    } else if (optSel === "WH_DESIGNPKG") {
        for (const vn of values) {
            let itemName = vn.items[1].item.name;
            if (vn.items.length > 2) {
                itemName = vn.items[2].item.name;
            }

            retval.set(vn, {name: itemName});
        }
    } else */
    {
        for (const vn of values) {
            let itmname = vn.items[1].item.name;

            if (itmname.includes("/") && itmname.length > 20) {

                itmname = itmname.split("/")[0] + "...";
            }
            if (vn.items.length > 2) {
                itmname += "/" + vn.items.map(itm => itm.item.name).slice(2).join("/");
            }
            retval.set(vn, {name: itmname});
        }
    }
    return retval;

}